import React, { useState } from "react";
import TextInput from "../../../components/elements/forms/TextInput";
import { FaRegEnvelope, FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import SubmitButton from "../../../components/elements/forms/SubmitButton";
import img from "../../../constant";
import { ILogin, ILoginError } from "../../../store/types/auth";
import { auth_user } from "../../../services/api/auth";
import { useAppDispatch } from "../../../store/hooks";
import { get_cookie } from "../../../config/cookie";
// import Navbar from "../../../components/Navbar2";

const Login: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  // const loading = useAppSelector(({ loading }) => loading.loading);
  const [show, showSet] = React.useState<"password" | "text">("password");
  const [loading, setLoading] = useState(false);
  const [data, dataSet] = React.useState<ILogin>({
    email: "",
    password: "",
  });
  const [error, errorSet] = React.useState<ILoginError>({
    email: "",
    password: "",
  });

  const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    dataSet((prev) => ({ ...prev, [name]: value }));
    errorSet((prev) => ({ ...prev, [name]: "" }));
  };

  const onSubmitHandler = async () => {
    let validate: boolean = false;
    if (!data.email) {
      validate = true;
      errorSet((prev) => ({ ...prev, email: "warning" }));
    }
    if (!data.password) {
      validate = true;
      errorSet((prev) => ({ ...prev, password: "warning" }));
    }
    if (validate) return;
    setLoading(true);
    const serial = await auth_user(data, dispatch, navigate);
    // localStorage.setItem("@serial", serial);
    if (serial) {
      localStorage.setItem("@serial", serial);
      navigate("/dashboard");
    }
    navigate("/dashboard");
    setLoading(false);
  };

  const onLoad = React.useCallback(() => {
    if (get_cookie("@serial")) navigate("/dashboard");
  }, [navigate]);

  React.useEffect(() => {
    onLoad();
  }, [onLoad]);

  return (
    <div className="font-abel bg-[#D9ECFF] h-screen">
      {/* <Navbar title="Request a demo" link="/request" /> */}
      <div className="grid md:grid-cols-2 gap-0 md:items-center h-full">
        <div className="col-span-1 h-full hidden md:block">
          <div className="bg-bgLogin bg-cover bg-center h-full">
            <div className="h-full w-full max-w-[588px] mx-auto text-white text-left flex flex-col items-left justify-evenly">
              <Link to={`/`}>
                <img
                  src={img.logoWhite}
                  alt="logo"
                  className="md:w-[100px] w-[65px]"
                />
              </Link>
              <h1 className="text-3xl md:text-[100px] md:leading-[98.2%]">
                AI Recruiter
              </h1>
              <div></div>
            </div>
          </div>
        </div>
        <div className="col-span-1 w-full h-full border-none rounded-lg px-4 md:px-0 py-10 md:py-20">
          <div className="h-[100%] w-full max-w-[650px] bg-[white] py-4 px-4 flex justify-center items-center md:rounded-tr-[20px] md:rounded-br-[20px] md:rounded-[30px] rounded-10">
            <div className="w-[100%] max-w-[500px]">
              <div className="text-center w-full mb-4">
                <div className="flex items-center justify-center mb-5 md:hidden">
                  <Link to={`/home`}>
                    <img
                      src={img.logo}
                      alt="logo"
                      className="md:w-[130px] w-[75px]"
                    />
                  </Link>
                </div>
                <h3 className="md:text-[50px] text-[32px]">Welcome Back</h3>
              </div>
              <div>
                <TextInput
                  label="EMAIL ADDRESS"
                  placeholder="Enter Email"
                  name="email"
                  status={error.email}
                  value={data.email}
                  onChange={onChangeHandler}
                  right_icon={
                    <FaRegEnvelope
                      size={20}
                      className="cursor-pointer"
                      color="#667185"
                    />
                  }
                />
                <TextInput
                  label="PASSWORD"
                  placeholder="Enter Password"
                  name="password"
                  type={show}
                  status={error.password}
                  value={data.password}
                  onChange={onChangeHandler}
                  container="my-3"
                  right_icon={
                    show === "text" ? (
                      <FaRegEyeSlash
                        size={20}
                        className="cursor-pointer"
                        onClick={() => showSet("password")}
                        color="#667185"
                      />
                    ) : (
                      <FaRegEye
                        size={20}
                        className="cursor-pointer"
                        onClick={() => showSet("text")}
                        color="#667185"
                      />
                    )
                  }
                />
                <div className="flex justify-between items-center my-7 align-center">
                  <label className="text-[15px]">
                    <input
                      type="checkbox"
                      className="text-secondary checked:bg-blue-500"
                    />{" "}
                    Remember me
                  </label>
                  <Link
                    to="/forget-password"
                    className="text-secondary text-[14px]"
                  >
                    Forgot Password?
                  </Link>
                </div>
                <div className="w-[100%]">
                  <SubmitButton
                    title="Log into Account"
                    onSubmitHandler={onSubmitHandler}
                    loading={loading}
                    className="font-[400] text-white md:hover:bg-[white] md:hover:text-secondary hover:border-primary"
                  />
                  <p className="text-[14px] pt-4">
                    New here?{" "}
                    <Link to="/request" className="text-secondary">
                      Request a Demo
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
